class CollectionGridSliderVaillant extends HTMLElement {
  connectedCallback() {
    this.slides = [...this.querySelectorAll('[data-grid-slider-slide]')];
    this.track = this.querySelector('[data-grid-slider-track]');
    this.progress = this.querySelector('[data-grid-slider-progress]');
    this.previousButton = this.querySelector('[data-grid-slider-previous]');
    this.nextButton = this.querySelector('[data-grid-slider-next]');
    this.activeIndex = 0;

    if (!this.track || this.slides.length < 2) return;

    this.previousButton?.addEventListener('click', () => this.move(-1));
    this.nextButton?.addEventListener('click', () => this.move(1));
    this.track.addEventListener('scroll', () => this.syncFromScroll(), { passive: true });

    this.syncFromScroll();
  }

  move(direction) {
    const nextIndex = (this.activeIndex + direction + this.slides.length) % this.slides.length;
    this.showSlide(nextIndex);
  }

  showSlide(index) {
    const slide = this.slides[index];
    if (!slide) return;

    this.activeIndex = index;
    slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    this.updateState();
  }

  syncFromScroll() {
    if (!this.track) return;

    const trackRect = this.track.getBoundingClientRect();
    let closestIndex = 0;
    let closestDistance = Number.POSITIVE_INFINITY;

    this.slides.forEach((slide, index) => {
      const distance = Math.abs(slide.getBoundingClientRect().left - trackRect.left);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });

    this.activeIndex = closestIndex;
    this.updateState();
  }

  updateState() {
    this.slides.forEach((slide, index) => {
      const isActive = index === this.activeIndex;
      slide.classList.toggle('is-active', isActive);
      slide.setAttribute('aria-hidden', String(!isActive));
    });

    this.progress?.style.setProperty('--grid-slider-index', String(this.activeIndex));
  }
}

if (!customElements.get('collection-grid-slider-vaillant')) {
  customElements.define('collection-grid-slider-vaillant', CollectionGridSliderVaillant);
}
